/**
 * @name: 开发者账号逻辑处理
 * @param {
 *  props: 创建编辑信息
 *  id：操作对象id
 *  emit
 * }
 * @return  创建，编辑，停用，操作记录，续费
 */
import { ref, getCurrentInstance } from 'vue';
import { ElMessageBox, ElMessage } from 'element-plus';
import { formatTime } from '@toy/utils';

import {
  GetV1AccountInfoApiResItem,
  // IAccountInfoParams,
  isEnabledType,
  IAccountInfoLogs,
} from '@/api/manage-app/account-info/index.d';

import {
  AddAccountInfoApi, // 添加用户
  putV1AccountInfoApi, // 更新用户
  putV1AccountInfoUpdateEnableApi, // 停用
  reneAccountInfo, // 续费
  accountInfoLogs, // 操作日志
} from '@/api/manage-app/account-info';

export const useCreatedDevAccount = (
  props = {} as any,
  emit = '' as any,
) => {
  const currentInstance = getCurrentInstance()!;

  // 编辑
  const createdDevVisible = ref<boolean>(false);
  const accountItem = ref({});
  const handelEdit = (row: GetV1AccountInfoApiResItem) => {
    const {
      id,
      accountId,
      accountName,
      accountEmail,
      openingTime,
      overdueTime,
      holder,
    } = row;
    accountItem.value = {
      id,
      accountId,
      accountName,
      accountEmail,
      holder,
      openingTime: formatTime(openingTime!),
      overdueTime: formatTime(overdueTime!),
    };
    createdDevVisible.value = true;
  };

  // 创建
  const handleClose = () => {
    (currentInstance.refs.ruleForm as any).resetFields();
    emit('update:visible', false);
  };
  const handleCreated = () => {
    accountItem.value = {};
    createdDevVisible.value = true;
  };
  const handleSave = async () => {
    try {
      await (currentInstance.refs.ruleForm as any).validate();
      if (props.value.id) {
        // 更新
        await putV1AccountInfoApi({
          ...props.value,
          openingTime: formatTime(props.value.openingTime),
          overdueTime: formatTime(props.value.overdueTime),
        });
      } else {
        // 新增
        await AddAccountInfoApi({
          ...props.value,
          openingTime: formatTime(props.value.openingTime),
          overdueTime: formatTime(props.value.overdueTime),
        });
      }
      ElMessage.success('操作成功！');
      emit('handleSearch');
      handleClose();
    } catch (e) {
      console.log(e);
    }
  };

  // 停用
  const disabledVisible = ref<boolean>(false);
  const handleDisClose = () => {
    (currentInstance.refs.disabledForm as any).resetFields();
    emit('update:visible', false);
  };
  const handleDisabled = (row: GetV1AccountInfoApiResItem) => {
    const isDisabled = row?.appInfoVos?.map((item) => {
      return item.isEnabled!;
    }).every((info: isEnabledType) => {
      return info === 'NO';
    });
    // 开发者账号下左右APP都停用了才可以停用
    if (isDisabled) {
      accountItem.value = row;
      disabledVisible.value = true;
    } else {
      ElMessage.warning('该账号下有已启用的APP，禁止停用！');
    }
  };
  const handleDisSave = async (id: string) => {
    await (currentInstance.refs.disabledForm as any).validate();
    await putV1AccountInfoUpdateEnableApi({
      remark: props.value.remark,
      id,
      isEnabled: 'NO',
    });
    emit('handleSearch');
    handleDisClose();
  };

  // 启用
  const handleEnable = (row: GetV1AccountInfoApiResItem, searchCb: any) => {
    ElMessageBox.confirm(`是否确认启用[${row.accountName}_${row.accountId}]  的开发者账号？`, '温馨提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(async () => {
      await putV1AccountInfoUpdateEnableApi({
        id: row.id!,
        isEnabled: 'YES',
      });
      ElMessage.success('操作成功！');
      searchCb();
    }).catch(() => {
    });
  };

  // 续费
  const handleRenew = (row: GetV1AccountInfoApiResItem, searchCb: any) => {
    const date = new Date(row.overdueTime as any);
    date.setFullYear(date.getFullYear() + 1);
    date.setDate(date.getDate() - 1);
    ElMessageBox.confirm(
      `是否确认续费 [${row.accountName}_${row.accountId}] 的开发者账号？到期日期更新为：${formatTime(date)}`,
      '温馨提示',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      },
    ).then(async () => {
      await reneAccountInfo(row.id!);
      ElMessage.success('操作成功！');
      searchCb();
    }).catch(() => {
    });
  };

  // 操作日志
  const logVisible = ref<boolean>(false);
  const gridData = ref<IAccountInfoLogs[]>([]);
  const tableLoading = ref(false);
  const handleLogClose = () => {
    emit('update:visible', false);
  };
  const handleShowLogs = async (row: GetV1AccountInfoApiResItem) => {
    logVisible.value = true;
    const res = await accountInfoLogs(row.id!);
    gridData.value = res?.data;
  };

  return {
    // 创建
    createdDevVisible,
    handleCreated,
    handleSave,
    handleClose,
    handelEdit,
    accountItem,

    // 停用
    disabledVisible,
    handleDisClose,
    handleDisabled,
    handleDisSave,

    // 启用
    handleEnable,

    // 续费
    handleRenew,

    // 操作日志
    logVisible,
    handleShowLogs,
    handleLogClose,
    gridData,
    tableLoading,
  };
};
